import Image from "next/image"
import styled from "styled-components"
import Button, { ButtonProps } from "react-bootstrap/Button"
import { FC } from "react"

const StyledGoogleButton: FC<ButtonProps> = styled(Button)`
border: 1px solid #757575;
padding: 0.5rem;
background: #ffffff;
:hover{
  background: rgba(0, 0, 0,0.1);
 }
`

type Props = {
  onClick?: (event: React.MouseEvent | React.KeyboardEvent) => void
}

export default function GoogleLoginButton({ onClick }: Props) {
  return (
    <StyledGoogleButton variant="light" className="w-100 fw-semibold" onClick={onClick}>
      <Image
        priority
        src="/assets/svg/google-icon.svg"
        height={22}
        width={22}
        alt="Google"
      />
      &nbsp;
      Google
    </StyledGoogleButton>
  )
}
